import React, { useState } from 'react';
import { Slider, styled, TextField, FormControl, Typography } from '@mui/material';

const SliderInputContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '70% 30%',
  alignItems: 'center',
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '50% 50%',
  },
}));

interface Props {
  label: string;
  defaultValue: number;
  maxValue: number;
  onChange: (arg0: number) => void;
}

export const InputSlider = ({ label, defaultValue, maxValue, onChange }: Props) => {
  const [value, setValue] = useState<number>(defaultValue);

  const handleSliderChange = (_event: any, newValue: any) => {
    setValue(newValue);
    onChange(newValue);
  };

  const handleInputChange = (event: any) => {
    try {
      const val = parseInt(event.target.value) > 0 ? parseInt(event.target.value) : 1;
      setValue(val);
      onChange(val);
    } catch (err) {
      setValue(1);
      onChange(1);
    }
  };

  return (
    <>
      <SliderInputContainer>
        <Typography variant="body1">{label}</Typography>
        <div>
          <FormControl fullWidth>
            <TextField
              value={value}
              onChange={handleInputChange}
              data-testid="simple-calculator-invested-amount"
              variant="outlined"
              label={label}
              inputProps={{
                min: 0,
                type: 'number',
                'aria-labelledby': 'input-slider',
                'data-hj-whitelist': true,
              }}
            />
          </FormControl>
        </div>
      </SliderInputContainer>
      <Slider
        value={value}
        min={0}
        max={maxValue}
        onChange={handleSliderChange}
        onChangeCommitted={handleSliderChange}
        aria-labelledby="input-slider"
      />
    </>
  );
};
